$('.video').parent().click(function () {
  if($(this).children(".video").get(0).paused){        $(this).children(".video").get(0).play();   $(this).children(".playpause").fadeOut();
    }else{       $(this).children(".video").get(0).pause();
  $(this).children(".playpause").fadeIn();
    }
});



$('.video-slider-box').slick({
  centerMode: true,
  centerPadding: '100px',
  slidesToShow: 1,
  arrows: true,
  dots: false,
  autoplay:false,
  autoplaySpeed:2500,  
  responsive: [
    {
      breakpoint: 990,
      settings: {
      arrows: false,
      dots: false,
      centerMode: false,
      centerPadding: '0px',
      slidesToShow: 1
      }
    }
  ]
});




